'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';

angular.module('reporting.ctrls', [])
    .controller('LineItemHistoryReportController', LineItemHistoryReportController)
    .controller('LineItemReportsController', LineItemReportsController)
    .controller('MasterReportController', MasterReportController)
    .controller('OrderHistoryReportController', OrderHistoryReportController)
    .controller('OrderReportController', OrderReportController)
    .controller('SlotBookingReportController', SlotBookingReportController)
    .controller('TasksReportsController', TasksReportsController);

LineItemHistoryReportController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function LineItemHistoryReportController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {

    $scope.tableHide = true;
    $scope.tableHideInfo = true;
    var REPORT_TEMPLATE_TYPE_LINE_ITEM_HISTORY = 7;

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Line Item History Columns Data
     */
    var getColumns = function() {
        ReportService.getLineItemHistoryColumns().then(function(success) {
            $scope.lineItemHistoryColumns = ReportService.lineItemHistoryColumns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadertitle = "Fetching Line Item History";
        $rs.loadingInProgress = true;
        ReportService.getLineItemHistoryFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.lineItemHistoryFilters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        });
    };

    var getLineItemHistoryRows = function(filterParams) {
        $rs.loadertitle = "Generating Table";
        $rs.loadingInProgress = true;
        ReportService.getLineItemHistoryRows(filterParams, ClusterService.clusterIds).then(function(success) {
            var lineItemHistoryRows = ReportService.lineItemHistoryRows;

            if (lineItemHistoryRows) {
                $scope.lineItemHistoryReport = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = lineItemHistoryRows.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = lineItemHistoryRows[i][key];
                    }
                    $scope.lineItemHistoryReport.push(obj);
                }
                $scope.showTable = true;
                $rs.loadingInProgress = false;
                $scope.tableHideInfo = false;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_LINE_ITEM_HISTORY, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;

            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_LINE_ITEM_HISTORY
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();

            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }
        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getLineItemHistoryRows(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters').then(function() {
            $scope.columns = [];
            $scope.filterObj = {};
            $scope.lineItemHistoryColumns = [];
            $scope.filterColumns = [];
            $scope.filters = [];
            $scope.filterTypes = {};
            $scope.reportTemplates = [];
            $scope.onSaveTemplate = false;
            $scope.showTable = false;
            $scope.isEdit = false;
            $scope.saveText = "Save Template";

            DateRangeService.init('enabled');
            getColumns();
        });

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

LineItemReportsController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function LineItemReportsController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {
    var REPORT_TEMPLATE_TYPE_LINE_ITEM = 2;


    $scope.tableHide = true;
    $rs.tableHideInfo = true;



    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Order Columns Data
     */
    var getColumns = function() {
        ReportService.getLineItemColumns().then(function(success) {
            $scope.lineItemColumns = ReportService.lineItemColumns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Line Item Report";

        ReportService.getLineItemFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.lineItemFilters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide1 = false;
        });
    };

    var getLineItems = function(filterParams) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating  Table";
        ReportService.getLineItems(filterParams, ClusterService.clusterIds).then(function(success) {
            var lineItems = ReportService.lineItems;

            if (lineItems) {
                $scope.lineItemReports = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = lineItems.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = lineItems[i][key];
                    }
                    $scope.lineItemReports.push(obj);
                }
                $scope.showTable = true;
                $rs.loadingInProgress = false;
                $scope.tableHideInfo = false;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_LINE_ITEM, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_LINE_ITEM
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();

            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }

        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getLineItems(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        DateRangeService.init('enabled');

        $scope.columns = [];
        $scope.filterObj = {};
        $scope.lineItemColumns = [];
        $scope.filterColumns = [];
        $scope.filters = [];
        $scope.reportTemplates = [];
        $scope.onSaveTemplate = false;
        $scope.showTable = false;
        $scope.isEdit = false;
        $scope.filterTypes = {};
        $scope.saveText = "Save Template";

        getColumns();

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

MasterReportController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function MasterReportController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {
    var REPORT_TEMPLATE_TYPE_MASTER = 4;
    $scope.tableHide = true;
    $scope.tableHideInfo = true;

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Master Columns Data
     */
    var getColumns = function() {
        ReportService.getMasterColumns().then(function(success) {
            $scope.masterColumns = ReportService.masterColumns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        ReportService.getMasterFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.masterFilters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;

        });
    };

    var getMasterRows = function(filterParams) {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating Table";

        ReportService.getMasterRows(filterParams, ClusterService.clusterIds).then(function(success) {
            var masterRows = ReportService.masterRows;

            if (masterRows) {
                $scope.masterReport = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = masterRows.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = masterRows[i][key];
                    }
                    $scope.masterReport.push(obj);
                }
                $scope.showTable = true;
            }
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Master";
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_MASTER, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
                $rs.loadingInProgress = false;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                $rs.loadingInProgress = false;
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            if (savedTemplate) {
                getReportTemplates();
                $scope.showTemplate();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var updatedTemplate = ReportService.template;
            if(updatedTemplate) {
                getReportTemplates();
                $scope.showTemplate();
                $ioAlert.show('Success!', 'Template Updated Successfully', 'success');    
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_MASTER
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();

            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }

        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getMasterRows(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters').then(function() {
            $scope.columns = [];
            $scope.filterObj = {};
            $scope.masterColumns = [];
            $scope.filterColumns = [];
            $scope.filters = [];
            $scope.filterTypes = {};
            $scope.reportTemplates = [];
            $scope.onSaveTemplate = false;
            $scope.showTable = false;
            $scope.isEdit = false;
            $scope.saveText = "Save Template";

            DateRangeService.init('enabled');
            getColumns();
        });

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

OrderHistoryReportController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function OrderHistoryReportController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {
    var REPORT_TEMPLATE_TYPE_ORDER_HISTORY = 6;

    $scope.tableHide = true;
    $scope.tableHideInfo = true;


    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Order History Columns Data
     */
    var getColumns = function() {
        ReportService.getOrderHistoryColumns().then(function(success) {
            $scope.orderHistoryColumns = ReportService.orderHistoryColumns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Order History";

        ReportService.getOrderHistoryFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.orderHistoryFilters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        });
    };

    var getOrderHistoryRows = function(filterParams) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating  Table";

        ReportService.getOrderHistoryRows(filterParams, ClusterService.clusterIds).then(function(success) {
            var orderHistoryRows = ReportService.orderHistoryRows;

            if (orderHistoryRows) {
                $scope.orderHistoryReport = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = orderHistoryRows.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = orderHistoryRows[i][key];
                    }
                    $scope.orderHistoryReport.push(obj);
                }
                $scope.showTable = true;
            }
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_ORDER_HISTORY, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });

    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');

            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_ORDER_HISTORY
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();

            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }
        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getOrderHistoryRows(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters').then(function() {
            $scope.columns = [];
            $scope.filterObj = {};
            $scope.orderHistoryColumns = [];
            $scope.filterColumns = [];
            $scope.filters = [];
            $scope.filterTypes = {};
            $scope.reportTemplates = [];
            $scope.onSaveTemplate = false;
            $scope.showTable = false;
            $scope.isEdit = false;
            $scope.saveText = "Save Template";

            DateRangeService.init('enabled');
            getColumns();
        });

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

OrderReportController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function OrderReportController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {
    var REPORT_TEMPLATE_TYPE_ORDER = 1;
    $scope.tableHide = true;
    $scope.tableHideInfo = true;

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Order Columns Data
     */
    var getColumns = function() {
        ReportService.getOrderColumns().then(function(success) {
            $scope.orderColumns = ReportService.columns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Orders";
        ReportService.getOrderFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.filters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        });
    };

    /*
     * Get the required data based on the filters given to popluate in the table
     */
    var getOrders = function(filterParams) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating Table";


        ReportService.getOrders(filterParams, ClusterService.clusterIds).then(function(success) {
            var orders = ReportService.orders;

            if (orders) {
                $scope.orderReports = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = orders.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = orders[i][key];
                    }
                    $scope.orderReports.push(obj);
                }

                $scope.showTable = true;
                $rs.loadingInProgress = false;
                $scope.tableHideInfo = false;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');

            $scope.tableHideInfo = false;
            $rs.loadingInProgress = false;

        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_ORDER, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');

            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_ORDER
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();

            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }
        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getOrders(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters').then(function() {
            $scope.columns = [];
            $scope.filterObj = {};
            $scope.orderColumns = [];
            $scope.filterColumns = [];
            $scope.filters = [];
            $scope.filterTypes = {};
            $scope.reportTemplates = [];
            $scope.onSaveTemplate = false;
            $scope.showTable = false;
            $scope.isEdit = false;
            $scope.saveText = "Save Template";

            DateRangeService.init('enabled');
            getColumns();
        });

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

SlotBookingReportController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function SlotBookingReportController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {
    var REPORT_TEMPLATE_TYPE_SLOT_BOOKING = 5;


    $scope.tableHide = true;
    $scope.tableHideInfo = true;

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Slot Booking Columns Data
     */
    var getColumns = function() {
        ReportService.getSlotBookingColumns().then(function(success) {
            $scope.slotBookingColumns = ReportService.columns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadertitle = "Fetching slot Bookings";
        $rs.loadingInProgress = true;
        ReportService.getSlotBookingFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.filters;
            if ($scope.filterColumns) {
                for (var x = 0; x < $scope.filterColumns.length; x++) {
                    var filter = $scope.filterColumns[x];
                    $scope.filterTypes[filter.model] = filter.type;
                }
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        });
    };

    /*
     * Get the required data based on the filters given to populate in the table
     */
    var getSlotBookings = function(filterParams) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating  Table";


        ReportService.getSlotBookings(filterParams, ClusterService.clusterIds).then(function(success) {
            var slotBookings = ReportService.slotBookings;

            if (slotBookings) {
                $scope.slotBookingReport = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = slotBookings.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = slotBookings[i][key];
                    }
                    $scope.slotBookingReport.push(obj);
                }
                $scope.showTable = true;
            }
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_SLOT_BOOKING, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');

            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_SLOT_BOOKING
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();
            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }
        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getSlotBookings(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }));
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters').then(function() {
            $scope.columns = [];
            $scope.filterObj = {};
            $scope.slotBookingColumns = [];
            $scope.filterColumns = [];
            $scope.filters = [];
            $scope.filterTypes = {};
            $scope.reportTemplates = [];
            $scope.onSaveTemplate = false;
            $scope.showTable = false;
            $scope.isEdit = false;
            $scope.saveText = "Save Template";

            DateRangeService.init('enabled');
            getColumns();
        });

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}

TasksReportsController.$inject = ['$rootScope', '$scope', '$ioAlert', 'ReportService', '$modal', '$filter', 'ClusterService', 'DateRangeService', 'UserService', 'ModalService', '$location', '$anchorScroll'];

function TasksReportsController($rs, $scope, $ioAlert, ReportService, $modal, $filter, ClusterService, DateRangeService, UserService, ModalService, $location, $anchorScroll) {


    $scope.tableHide = true;
    $scope.tableHideInfo = true;

    var REPORT_TEMPLATE_TYPE_TASK = 3;

    $scope.dateOptions = {
        formatYear: 'yy',
        startingDay: 1,
        showWeeks: false
    };

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getFilters();
        getReportTemplates();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    /*
     * GET Order Columns Data
     */
    var getColumns = function() {
        ReportService.getTaskColumns().then(function(success) {
            $scope.taskColumns = ReportService.taskColumns;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * GET Filter columns data
     */
    var getFilters = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching Tasks";
        ReportService.getTaskFilters(ClusterService.clusterIds).then(function(success) {
            $scope.filterColumns = ReportService.taskFilters;

            for (var x = 0; x < $scope.filterColumns.length; x++) {
                var filter = $scope.filterColumns[x];
                $scope.filterTypes[filter.model] = filter.type;
            }
            if ($scope.filters.length) {
                for (var i = 0; i < $scope.filterColumns.length; i++) {
                    if ($scope.filterColumns[i]) {
                        for (var j = 0, jlen = $scope.filters.length; j < jlen; j++) {
                            if ($scope.filterColumns[i].model == $scope.filters[j].model) {
                                $scope.filterColumns.splice(i, 1);
                                i--;
                                break;
                            }
                        }
                    }
                }
            }
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHide = false;
        });
    };

    var getTasks = function(filterParams) {

        $rs.loadingInProgress = true;
        $rs.loadertitle = "Generating  Table";
        ReportService.getTasks(filterParams, ClusterService.clusterIds).then(function(success) {
            var tasks = ReportService.tasks;

            if (tasks) {
                $scope.taskReports = [];

                //Need to map the columns data selected by user
                for (var i = 0, len = tasks.length; i < len; i++) {
                    var obj = {};
                    for (var j = 0, size = $scope.columns.length; j < size; j++) {
                        var key = $scope.columns[j].key;
                        obj[key] = tasks[i][key];
                    }
                    $scope.taskReports.push(obj);
                }
                $scope.showTable = true;
                $rs.loadingInProgress = false;
                $scope.tableHideInfo = false;
            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            $rs.loadingInProgress = false;
            $scope.tableHideInfo = false;
        });
    };

    /*
     * get the list of Templates saved
     */
    var getReportTemplates = function() {
        ReportService.getPopulatedReportTemplates(REPORT_TEMPLATE_TYPE_TASK, ClusterService.clusterIds).then(
            function(success) {
                $scope.reportTemplates = ReportService.templates;
            },
            function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
    };

    /*
     * Save New Template
     */
    var addReportTemplate = function(template) {
        ReportService.addReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;

            if (savedTemplate) {
                getReportTemplates();
                $ioAlert.show('Success!', 'Template Saved Successfully', 'success');

            }
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     * Update the existing Template
     */
    var updateReportTemplate = function(template) {
        ReportService.updateReportTemplate(template).then(function(success) {
            var savedTemplate = ReportService.template;
            getReportTemplates();
            $ioAlert.show('Success!', 'Template Updated Successfully', 'success');
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    function saveReportingModal(type, data) {
        return $modal.open(ModalService.returnModalType(type, { data: data }));
    }

    var getTemplateParams = function() {
        var filterParams = {};
        var keys = Object.keys($scope.filterObj);

        for (var i = 0, len = keys.length; i < len; i++) {
            if ($scope.filterTypes[keys[i]] == 'date') {
                filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
            } else {
                filterParams[keys[i]] = $scope.filterObj[keys[i]];
            }
        }

        filterParams['startDate'] = DateRangeService.startDate;
        filterParams['endDate'] = DateRangeService.endDate;
        filterParams['clusterId'] = ClusterService.clusterIds;

        return filterParams;
    };

    $scope.saveReportTemplate = function() {
        saveReportingModal('reporting', $scope.templateName).result.then(function(formObj) {
            var template = {
                "name": formObj.name,
                "typeId": REPORT_TEMPLATE_TYPE_TASK
            };
            if ($scope.isEdit) {
                template.id = $scope.templateId;
            }
            template.columns = [];
            template.filters = [];
            for (var i = 0; i < $scope.columns.length; i++) {
                template.columns.push($scope.columns[i].name);
            }
            for (var j = 0; j < $scope.filters.length; j++) {
                template.filters.push($scope.filters[j].name);
            }
            template.selections = getTemplateParams();
            if ($scope.isEdit) {
                template.id = $scope.templateId;
                updateReportTemplate(template);
            } else {
                addReportTemplate(template);
            }

        }, function() {});
    };

    $scope.generateTable = function() {
        if (DateRangeService.startDate && DateRangeService.endDate) {
            if ($scope.columns.length == 0) {
                $ioAlert.show('Error!', 'Please select at least one column', 'error');
            } else {
                var filterParams = {};
                var keys = Object.keys($scope.filterObj);

                for (var i = 0, len = keys.length; i < len; i++) {
                    if ($scope.filterTypes[keys[i]] == 'date') {
                        filterParams[keys[i]] = $filter('date')($scope.filterObj[keys[i]], 'yyyy-MM-dd');
                    } else if ($scope.filterTypes[keys[i]] == 'multi') {
                        var key = keys[i];
                        key = key + '[]';
                        filterParams[key] = $scope.filterObj[keys[i]];
                    } else {
                        filterParams[keys[i]] = $scope.filterObj[keys[i]];
                    }
                }

                getTasks(_.assign(filterParams, { startDate: DateRangeService.startDate, endDate: DateRangeService.endDate }), ClusterService.clusterId);
            }
        } else {
            $ioAlert.show('Error!', 'Please select a start and end date.', 'error');
        }
    };

    /*
     * Show detailed View of Template
     */
    $scope.showTemplate = function(template) {
        if (template) {
            $scope.isEdit = true;
            $scope.saveText = "Update Template";
            $scope.templateName = template.name;
            $scope.templateId = template.id;
            $rs.$broadcast('loadTemplate', template);

            //$scope.generateTable();
            $location.hash('templateView');
            $anchorScroll();
            $location.hash('');
        } else {
            $scope.isEdit = false;
            $scope.saveText = "Save Template";
            $scope.templateName = "";
            $scope.templateId = "";
            $rs.$broadcast('loadTemplate');
        }
    };

    $scope.exportTable = function() {
        $scope.$broadcast('export-excl', {});
    };

    var init = function() {
        ClusterService.initCluster($rs.userRole, 'multiSelectWithAllClusters');
        DateRangeService.init('enabled');

        $scope.columns = [];
        $scope.filterObj = {};
        $scope.taskColumns = [];
        $scope.filterColumns = [];
        $scope.filters = [];
        $scope.reportTemplates = [];
        $scope.onSaveTemplate = false;
        $scope.showTable = false;
        $scope.isEdit = false;
        $scope.filterTypes = {};
        $scope.saveText = "Save Template";

        getColumns();

        $('.toggler').click(function(e) {
            e.preventDefault();
            var $icon = $(this).find('i.icon');

            if ($icon.hasClass('icon-caret-right')) {
                $icon.removeClass('icon-caret-right').addClass('icon-caret-down');
            } else {
                $icon.removeClass('icon-caret-down').addClass('icon-caret-right');
            }
        });
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {});
    }
}